import { GetterTree, MutationTree, Module } from 'vuex';
import { SidebarState, RootState } from '@/types';

type SidebarGetter = GetterTree<SidebarState, RootState>;

export const initialState = (): SidebarState => {
  return {
    initialState,
    isSidebarCollapsed: false,
  };
};

export const getters: SidebarGetter = {
  isSidebarCollapsed: (state) => state.isSidebarCollapsed,
};

export const mutations: MutationTree<SidebarState> = {
  setSidebarCollapsed(state, collapsed) {
    state.isSidebarCollapsed = collapsed;
  },
};

export const sidebar: Module<SidebarState, RootState> = {
  state: initialState(),
  getters,
  mutations,
};
